import React from 'react';
import { findNodeHandle, View } from 'react-native';
import { TouchableHighlight, TWCText } from '@components';

import { settingsMenuTestIDs, settingsPageTestIDs } from '@constants';
import { useContextReference } from '@hooks';
import { navigationService } from '@services';

import { styles } from './styles';

import { DEBUG, isAndroid } from '../../../helpers/Platform';
import { DebugMenuIDs } from '../../debug/DebugMenuIDs';
import { TWCButton } from '../../focusable/TWCButton/TWCButton';

export const SettingsDebug = DEBUG
  ? () => {
      const settingsDebugMenuButtonReference = useContextReference<TouchableHighlight>(
        settingsPageTestIDs.debug.settingsDebugMenuButton,
      );

      const settingsMenuDebugReference = useContextReference(settingsMenuTestIDs.debug);

      const nextFocusLeft = isAndroid
        ? findNodeHandle(settingsMenuDebugReference?.current || null)
        : settingsMenuDebugReference?.current;

      return (
        <View style={styles.settingsWrapper}>
          <View style={styles.settingsContent}>
            <TWCText testID={settingsPageTestIDs.signOut.settingsSignOutText} variant={'regularText36'}>
              {'Debug Menu'}
            </TWCText>
          </View>
          <TWCButton
            nativeID={settingsPageTestIDs.debug.settingsDebugMenuButton}
            nextFocusLeft={nextFocusLeft}
            ref={settingsDebugMenuButtonReference}
            testID={settingsPageTestIDs.debug.settingsDebugMenuButton}
            title={'Go to debug'}
            onPress={() => navigationService.navigate(DebugMenuIDs.debugMenuPage)}
          />
        </View>
      );
    }
  : null;
